var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Base } from "../../framework/base";
import { EditItem } from "../common/editItem";
import { EnumHelper, InstantMessageChannelUserActiveState, InstantMessageChannelUserType } from "../enums";
var InstantMessageChannelEditUserItem = /** @class */ (function (_super) {
    __extends(InstantMessageChannelEditUserItem, _super);
    function InstantMessageChannelEditUserItem(obj) {
        var _this = _super.call(this, obj) || this;
        _this.companyId = obj && obj.companyId || "";
        _this.userType = obj && obj.userType || InstantMessageChannelUserType.User;
        _this.userCode = obj && obj.userCode || "";
        _this.firstName = obj && obj.firstName || "";
        _this.lastName = obj && obj.lastName || "";
        _this.picture = obj && obj.picture || "";
        _this.activeState = obj && obj.activeState || InstantMessageChannelUserActiveState.Rejected;
        return _this;
    }
    InstantMessageChannelEditUserItem.prototype.getName = function () {
        var _a, _b;
        return (((_a = this.lastName) !== null && _a !== void 0 ? _a : "") + " " + ((_b = this.firstName) !== null && _b !== void 0 ? _b : "")).trim();
    };
    InstantMessageChannelEditUserItem.prototype.getHash = function () {
        var _a;
        return _super.prototype.getHash.call(this) + "#" + ((_a = this.companyId) !== null && _a !== void 0 ? _a : "") + "#" + this.userType.toString(10) + "#" + this.activeState.toString(10);
    };
    InstantMessageChannelEditUserItem.prototype.getIsInvited = function () {
        return EnumHelper.isEqual(this.activeState, InstantMessageChannelUserActiveState.Invited);
    };
    InstantMessageChannelEditUserItem.prototype.getIsActive = function () {
        return EnumHelper.isEqual(this.activeState, InstantMessageChannelUserActiveState.Active);
    };
    InstantMessageChannelEditUserItem.prototype.getIsRejected = function () {
        return EnumHelper.isEqual(this.activeState, InstantMessageChannelUserActiveState.Rejected);
    };
    InstantMessageChannelEditUserItem.sortInstantMessageChannelEditUserItems = function (items, column, asc) {
        if (!items && items.length < 2)
            return items;
        if (column === "userType") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.userType, b.userType)); });
        }
        else if (column === "userCode") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.userCode, b.userCode)); });
        }
        else if (column === "activeState") {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.numCompare(a.activeState, b.activeState)); });
        }
        else {
            return items.sort(function (a, b) { return (!a || !b) ? 0 : ((asc ? 1 : -1) * Base.strCompare(a.getName(), b.getName())); });
        }
    };
    return InstantMessageChannelEditUserItem;
}(EditItem));
export { InstantMessageChannelEditUserItem };
